module.exports = __webpack_public_path__ + "static/media/Home.e3718e33.svg";